import * as types from '../../contactUs/constants/ActionTypes';

const initialState = {
  q: '',
  error: false,
  experience: '',
  items: [],
  channel: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.RECEIVE_ARTICLE_SEARCH_RESPONSE:
      return Object.assign({}, state, {
        q: action.payload.q,
        experience: action.payload.experience,
        error: false,
        items: action.payload.items,
        channel: action.payload.channel,
      });
    case types.RECEIVE_ARTICLE_SEARCH_ERROR:
      return Object.assign({}, state, { q: action.payload.q, experience: action.payload.experience, items: [], error: true, channel: action.payload.channel });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./home/reducers/reducer-search-results.js